import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus(complexDenominator, c1, r1, r2, sImaginary) {
  var result = Complex.createComplex(r1 + r2, r1 * r2 * c1 * sImaginary).divide(complexDenominator);
  return result;
}

export function computeComplexFF() {
  return Complex.createComplex(0, 0);
}
